export default "__VITE_ASSET__DNiM2s7L__"